import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Shirt, PenLine, FileDown, X } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { SignaturePad } from "../SignaturePad";

const fr = (d) => (d ? new Date(d.length === 10 ? `${d}T12:00:00` : d).toLocaleDateString("fr-FR") : "");

const SignSheet = ({ h, onClose, onDone }) => {
  const [sig, setSig] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { const fd = new FormData(); fd.append("signature", sig, "signature.png"); await http.post(`/agent-app/equipment/handovers/${h.id}/sign`, fd); toast.success("Merci, fiche signée"); onDone(); onClose(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center" data-testid="agent-handover-sign">
      <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 space-y-3 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center"><h3 className="font-display font-extrabold text-lg text-[#0B2A7A] flex-1">Fiche de remise du {fr(h.created_at)}</h3><button onClick={onClose} aria-label="Fermer"><X className="h-5 w-5" /></button></div>
        <ul className="text-sm divide-y border rounded-lg">{h.items.map((i, k) => <li key={k} className="px-3 py-2 flex justify-between"><span>{i.label}{i.detail ? ` · ${i.detail}` : ""}</span><b>× {i.quantity}</b></li>)}</ul>
        <p className="text-xs text-slate-500">En signant, vous reconnaissez avoir reçu ces équipements et vous engagez à les restituer à la fin de votre mission ou sur demande.</p>
        <SignaturePad testid="agent-handover-pad" onChange={setSig} />
        <button disabled={!sig || busy} onClick={go} className="w-full py-3 rounded-xl bg-[#0B2A7A] text-white font-bold disabled:opacity-50" data-testid="agent-handover-sign-save">{busy ? "Envoi…" : "Je signe"}</button>
      </div>
    </div>
  );
};

const openPdf = async (id) => {
  try { const r = await http.get(`/agent-app/equipment/handovers/${id}/pdf`, { responseType: "blob" }); const u = URL.createObjectURL(r.data); window.open(u, "_blank"); setTimeout(() => URL.revokeObjectURL(u), 60000); }
  catch (e) { toast.error(formatApiError(e)); }
};

export const AgentEquipment = () => {
  const [d, setD] = useState(null);
  const [sign, setSign] = useState(null);
  const load = () => http.get("/agent-app/equipment").then((r) => setD(r.data)).catch((e) => { if (e?.response?.status !== 401) toast.error("Équipements indisponibles pour le moment"); });
  useEffect(() => { load(); }, []);
  if (!d || (!d.items.length && !d.handovers.length)) return null;
  const todo = d.handovers.filter((h) => !h.signatures?.recipient);
  return (
    <section data-testid="agent-equipment">
      <h2 className="font-display text-lg font-extrabold mb-2 text-[#0B2A7A] flex items-center gap-2"><Shirt className="h-5 w-5" />Mes équipements</h2>
      {todo.map((h) => (
        <button key={h.id} onClick={() => setSign(h)} className="w-full mb-2 flex items-center gap-3 bg-amber-50 border border-amber-300 rounded-xl px-4 py-3 text-left" data-testid={`agent-handover-todo-${h.id}`}>
          <PenLine className="h-5 w-5 text-amber-700" /><span className="flex-1 text-sm"><b>Fiche de remise à signer</b><br />{h.items.length} article(s) · {fr(h.created_at)}</span>
        </button>
      ))}
      <div className="bg-white border border-slate-200 rounded-xl divide-y">
        {d.items.map((i, k) => <div key={k} className="px-4 py-2.5 text-sm flex justify-between"><span>{i.name}{i.size ? ` · ${i.size}` : ""}</span><span className="text-slate-500">× {i.quantity} · {fr(i.issued_at)}</span></div>)}
      </div>
      {d.handovers.filter((h) => h.signatures?.recipient).slice(0, 3).map((h) => (
        <button key={h.id} onClick={() => openPdf(h.id)} className="mt-2 text-xs text-sky-700 font-semibold inline-flex items-center gap-1 mr-3" data-testid={`agent-handover-pdf-${h.id}`}><FileDown className="h-3.5 w-3.5" />Fiche signée du {fr(h.created_at)}</button>
      ))}
      {sign && <SignSheet h={sign} onClose={() => setSign(null)} onDone={load} />}
    </section>
  );
};
